import { createContext } from 'react';

export const CoeolyticsContext = createContext('coeolyticscontext');
